module.exports = __webpack_public_path__ + "img/93.96e49959.jpg";